import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, X, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { BeforeAfterSlider } from '../components/BeforeAfterSlider';

const BEFORE_AFTER_PROJECTS = [
  {
    id: 1,
    before: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/3w0rgbdz_Project%20A-%20Before.JPG",
    after: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/7b1tvn0q_Project%20A%20-%20After.JPG",
    title: "Project A"
  },
  {
    id: 2,
    before: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/3e5m6cu2_Project%20B-%20Before.jpg",
    after: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/mbr2n68t_Project%20B-%20After2.jpg",
    title: "Project B"
  },
  {
    id: 6,
    before: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/wr0nea9s_Santa%20Lucia%20Before.jpeg",
    after: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/rpkqjv8r_Santa%20Lucia-After1.jpg",
    title: "Santa Lucia"
  },
  {
    id: 7,
    before: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/y130o8s7_Gateway%20kitchen%20before.jpeg",
    after: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/zg8806v1_Gathway%20after.jpeg",
    title: "Gateway"
  },
  {
    id: 5,
    before: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/phj58zbw_9%20%281%29.png",
    after: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/v4xpnxrc_10%20%281%29.png",
    title: "Bathroom Renovation"
  }
];

const GALLERY_IMAGES = [
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_048130c6-d634-4556-a2f8-17438a24507e/artifacts/9gwndztb_Best%20Photo%202.png",
    title: 'Interior Finishing',
    category: 'multifamily',
    description: 'Modern interior finishing with hardwood floors and natural lighting.',
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_048130c6-d634-4556-a2f8-17438a24507e/artifacts/d5kn60ek_Best%20Photo%204.png",
    title: 'Bathroom Vanity',
    category: 'multifamily',
    description: 'Modern bathroom renovation with custom vanity and fixtures.',
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/rd3v22ww_6%20%281%29.png",
    title: 'Living Room Renovation',
    category: 'multifamily',
    description: 'Beautiful living space with hardwood floors and modern fireplace.',
  },
  {
    id: 6,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/yragvl5z_8%20%282%29.png",
    title: 'Water Damage Restoration',
    category: 'multifamily',
    description: 'Complete restoration with dark wood laminate flooring.',
  },
  {
    id: 7,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/v4xpnxrc_10%20%281%29.png",
    title: 'Full Bathroom Remodel',
    category: 'multifamily',
    description: 'Complete bathroom with tub, shower, and modern fixtures.',
  },
  {
    id: 9,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/u2xdur8m_SF%20Pt.%201.jpg",
    title: 'San Francisco Project — Part 1',
    category: 'multifamily',
    description: 'Multifamily renovation project in San Francisco.',
  },
  {
    id: 10,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/o2g9h095_SF%20Pt.%202.jpg",
    title: 'San Francisco Project — Part 2',
    category: 'multifamily',
    description: 'Continuation of the San Francisco multifamily project.',
  },
  {
    id: 11,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/rpkqjv8r_Santa%20Lucia-After1.jpg",
    title: 'Santa Lucia — After',
    category: 'multifamily',
    description: 'Completed multifamily transformation at Santa Lucia.',
  },
  {
    id: 13,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/cc7xrww6_Screenshot%202026-06-15%20at%203.51.53%E2%80%AFPM2.png",
    title: 'Office Tenant Improvement',
    category: 'commercial',
    description: 'Newly finished commercial office space with modern doors and lighting.',
  },
  {
    id: 14,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/0vr8v9ps_Screenshot%202026-06-15%20at%203.51.17%E2%80%AFPM.png",
    title: 'Warehouse Renovation',
    category: 'commercial',
    description: 'Mid-construction commercial warehouse build-out with framing and mezzanine work.',
  },
  {
    id: 15,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/04xkb0p2_Screenshot%202026-06-15%20at%203.50.25%E2%80%AFPM.png",
    title: 'Open Office Build-Out',
    category: 'commercial',
    description: 'Newly completed open commercial office space with luxury vinyl plank flooring and modern lighting.',
  },
  {
    id: 18,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/wza04ly1_Gateway_Exterior_2_fcnfwu.webp",
    title: 'Gateway Exterior',
    category: 'multifamily',
    description: 'Renovated multifamily property exterior with cedar accents, modern siding, and mature landscaping.',
  },
  {
    id: 19,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/3nqmcil5_Gateway_Model_Kitchen_2_nlnvaq.webp",
    title: 'Gateway Model Kitchen',
    category: 'multifamily',
    description: 'Modern model unit kitchen with granite countertops, stainless appliances, and curated artwork.',
  },
  {
    id: 20,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/gtojp6nj_12.webp",
    title: 'Furnished Bedroom Suite',
    category: 'multifamily',
    description: 'Fully staged bedroom with custom lighting, fresh paint, and modern finishes.',
  },
  {
    id: 21,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/w6t6c55h_24.webp",
    title: 'Shaker Kitchen Renovation',
    category: 'multifamily',
    description: 'Brand-new kitchen with white shaker cabinets, quartz counters, and gray subway tile backsplash.',
  },
  {
    id: 22,
    src: "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/2x8teb9q_22.webp",
    title: 'Compact U-Shape Kitchen',
    category: 'multifamily',
    description: 'Efficient U-shaped kitchen renovation with stainless appliances and modern shaker cabinetry.',
  },
];

const categories = [
  { id: 'all', label: 'All Projects' },
  { id: 'multifamily', label: 'Multifamily' },
  { id: 'commercial', label: 'Commercial' },
];

export const Gallery = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const filteredImages = activeCategory === 'all' 
    ? GALLERY_IMAGES 
    : GALLERY_IMAGES.filter(img => img.category === activeCategory);

  const openLightbox = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const navigateLightbox = (direction) => {
    const newIndex = direction === 'next' 
      ? (currentIndex + 1) % filteredImages.length
      : (currentIndex - 1 + filteredImages.length) % filteredImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(filteredImages[newIndex]);
  };

  return (
    <div className="min-h-screen pt-48" data-testid="gallery-page">
      {/* Before/After Section - First */}
      <section className="py-20 bg-ktm-white" data-testid="before-after-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div 
            className="text-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="font-chivo font-black text-4xl md:text-5xl text-ktm-navy leading-tight mb-4">
              Before &amp; After
            </h1>
            <p className="text-slate-600 text-lg max-w-2xl mx-auto">
              Witness the transformation. Our expert team turns outdated spaces into 
              stunning modern living areas.
            </p>
          </motion.div>

          <div className="grid lg:grid-cols-2 gap-8">
            {BEFORE_AFTER_PROJECTS.map((project) => (
              <BeforeAfterSlider
                key={project.id}
                beforeImage={project.before}
                afterImage={project.after}
                title={project.title}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Project Gallery Section */}
      <section className="py-20 bg-ktm-muted">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div 
            className="text-center max-w-3xl mx-auto mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-chivo font-black text-3xl md:text-4xl text-ktm-navy leading-tight mb-6">
              Project<br />
              <span className="text-ktm-red">Gallery</span>
            </h2>
            <p className="text-slate-600 text-lg leading-relaxed">
              Browse through our completed projects and see the quality of our work. 
              From multifamily renovations to commercial builds, each project showcases 
              our commitment to excellence.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Filter Controls */}
      <section className="py-8 bg-white border-b border-ktm-border sticky top-20 z-30">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-wrap justify-center gap-4" data-testid="gallery-filters">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                data-testid={`filter-${category.id}`}
                className={`px-6 py-3 font-bold uppercase tracking-wider text-sm transition-all ${
                  activeCategory === category.id
                    ? 'bg-ktm-navy text-white'
                    : 'bg-ktm-muted text-ktm-navy hover:bg-ktm-border'
                }`}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 bg-ktm-white" data-testid="gallery-grid">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div 
            className="grid md:grid-cols-2 gap-6"
            layout
          >
            <AnimatePresence mode="popLayout">
              {filteredImages.map((image, index) => (
                <motion.div
                  key={image.id}
                  layout
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.3 }}
                  className="group cursor-pointer relative aspect-[4/3] overflow-hidden"
                  onClick={() => openLightbox(image, index)}
                  data-testid={`gallery-item-${image.id}`}
                >
                  <img 
                    src={image.src} 
                    alt={image.title} 
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-ktm-navy/70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col justify-end p-6">
                    <span className="text-ktm-red text-sm font-bold uppercase tracking-wider mb-2">
                      {image.category}
                    </span>
                    <h3 className="text-white font-chivo font-bold text-xl mb-2">
                      {image.title}
                    </h3>
                    <p className="text-slate-300 text-sm">
                      {image.description}
                    </p>
                  </div>
                  {/* Corner accent */}
                  <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-ktm-red opacity-0 group-hover:opacity-100 transition-opacity" />
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>

          {filteredImages.length === 0 && (
            <div className="text-center py-12">
              <p className="text-slate-600">No projects found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Lightbox */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
            onClick={closeLightbox}
            data-testid="lightbox"
          >
            {/* Close Button */}
            <button
              className="absolute top-4 right-4 w-12 h-12 bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors z-10"
              onClick={closeLightbox}
              data-testid="lightbox-close"
              aria-label="Close lightbox"
            >
              <X className="w-6 h-6 text-white" />
            </button>

            {/* Navigation Buttons */}
            <button
              className="absolute left-4 w-12 h-12 bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors z-10"
              onClick={(e) => { e.stopPropagation(); navigateLightbox('prev'); }}
              data-testid="lightbox-prev"
              aria-label="Previous image"
            >
              <ChevronLeft className="w-6 h-6 text-white" />
            </button>
            <button
              className="absolute right-4 w-12 h-12 bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors z-10"
              onClick={(e) => { e.stopPropagation(); navigateLightbox('next'); }}
              data-testid="lightbox-next"
              aria-label="Next image"
            >
              <ChevronRight className="w-6 h-6 text-white" />
            </button>

            {/* Image Container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="max-w-5xl w-full"
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={selectedImage.src} 
                alt={selectedImage.title} 
                className="w-full h-auto max-h-[70vh] object-contain"
              />
              <div className="mt-4 text-center">
                <span className="text-ktm-red text-sm font-bold uppercase tracking-wider">
                  {selectedImage.category}
                </span>
                <h3 className="text-white font-chivo font-bold text-2xl mt-2">
                  {selectedImage.title}
                </h3>
                <p className="text-slate-400 mt-2">
                  {selectedImage.description}
                </p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* CTA Section */}
      <section className="py-24 bg-ktm-red">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-chivo font-black text-3xl md:text-4xl text-white mb-6">
              Like What You See?
            </h2>
            <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
              Let us create something amazing for you. Contact us today to discuss 
              your project and get a free quote.
            </p>
            <Link to="/contact?quote=true">
              <Button 
                className="bg-white text-ktm-navy h-14 px-8 rounded-none font-bold uppercase tracking-wider hover:bg-slate-100"
                data-testid="gallery-cta-btn"
              >
                Get Free Quote
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
